export class SaveSolutionStateError extends Error {

}
